import type { ReactNode } from 'react';
import styles from './InfoBanner.module.css';

export type InfoBannerProps = {
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
};

export const InfoBanner = ({ icon, children, className }: InfoBannerProps) => (
  <div
    className={className ? `${styles.banner} ${className}` : styles.banner}
    role="status"
  >
    {icon ? <span className={styles.icon}>{icon}</span> : null}
    <span>{children}</span>
  </div>
);
